export async function loadPersistedStandardAccessFlag() {
  return false;
}
